/*
 * Branded Best House: read-only look at the logo a visitor added anywhere on the site, for pages that don't load
 * Nick's logo tool (the company orders and design request forms) and for showing "Email me my designs" only once
 * a logo exists. Uses Nick's window.BBLogoStore when it's on the page; otherwise it reads the same IndexedDB record
 * he writes ('bb-logo' / 'logo' / 'current', 7 days) WITHOUT ever creating or changing anything: if the database
 * doesn't exist yet, the open is aborted so Nick's tool can still create it with its own store later.
 * window.BBHouseLogo.peek() -> Promise<{ name, blob } | null>. Never throws.
 */
(function () {
  'use strict';
  if (window.BBHouseLogo) return;
  var MAX_AGE = 7 * 24 * 3600 * 1000;

  function fromStore() {
    return window.BBLogoStore.load().then(function (f) { return f ? { name: f.name || 'logo', blob: f } : null; });
  }

  function fromDb() {
    return new Promise(function (resolve) {
      var req;
      // no version: open whatever version Nick's tool is on, so a future upgrade of his doesn't break this
      try { req = indexedDB.open('bb-logo'); } catch (e) { resolve(null); return; }
      // No database yet: abort so nothing is created (Nick's tool creates it, with its store, on its first save).
      req.onupgradeneeded = function () { try { req.transaction.abort(); } catch (e) { /* already aborting */ } };
      req.onerror = function () { resolve(null); };
      req.onblocked = function () { resolve(null); };
      req.onsuccess = function () {
        var db = req.result;
        db.onversionchange = function () { db.close(); }; // never stand in the way of Nick's tool upgrading it
        try {
          if (!db.objectStoreNames.contains('logo')) { db.close(); resolve(null); return; }
          var get = db.transaction('logo', 'readonly').objectStore('logo').get('current');
          get.onsuccess = function () {
            db.close();
            var rec = get.result;
            if (!rec || !rec.blob || Date.now() - (rec.at || 0) > MAX_AGE) { resolve(null); return; }
            resolve({ name: rec.name || 'logo', blob: rec.blob });
          };
          get.onerror = function () { db.close(); resolve(null); };
        } catch (e) { try { db.close(); } catch (e2) { /* closed */ } resolve(null); }
      };
    });
  }

  window.BBHouseLogo = {
    peek: function () {
      try {
        if (window.BBLogoStore && typeof window.BBLogoStore.load === 'function') return fromStore().catch(function () { return null; });
        if (!('indexedDB' in window)) return Promise.resolve(null);
        return fromDb();
      } catch (e) { return Promise.resolve(null); }
    }
  };
})();
